// Module and Role API slice for Redux Toolkit Query

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from '../../config';

const baseQuery = fetchBaseQuery({
  baseUrl: getApiBaseUrl(),
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const user = getState().user?.currentUser;
    if (user?.id) {
      headers.set('userid', user.id);
    }
    return headers;
  },
});

export const moduleRoleApi = createApi({
  reducerPath: 'moduleRoleApi',
  baseQuery,
  tagTypes: ['Module', 'Role'],
  endpoints: (builder) => ({
    // MODULES
    getModules: builder.query({
      query: () => ({ url: 'modules' }),
      providesTags: ['Module'],
    }),
    getModuleById: builder.query({
      query: (id) => ({ url: `modules/${id}` }),
      providesTags: (result, error, id) => [{ type: 'Module', id }],
    }),
    createModule: builder.mutation({
      query: (data) => ({ url: 'modules', method: 'POST', body: data }),
      invalidatesTags: ['Module'],
    }),
    updateModule: builder.mutation({
      query: ({ id, ...data }) => ({ url: `modules/${id}`, method: 'PUT', body: data }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Module', id }, 'Module'],
    }),
    deleteModule: builder.mutation({
      query: (id) => ({ url: `modules/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Module'],
    }),
    // ROLES
    getRoles: builder.query({
      query: () => ({ url: 'roles' }),
      providesTags: ['Role'],
    }),
    getRoleById: builder.query({
      query: (id) => ({ url: `roles/${id}` }),
      providesTags: (result, error, id) => [{ type: 'Role', id }],
    }),
    getRolePermissions: builder.query({
      query: (id) => ({ url: `roles/${id}/permissions` }),
      providesTags: (result, error, id) => [{ type: 'Role', id }],
    }),
    createRole: builder.mutation({
      query: (data) => ({ url: 'roles', method: 'POST', body: data }),
      invalidatesTags: ['Role'],
    }),
    updateRole: builder.mutation({
      query: ({ id, ...data }) => ({ url: `roles/${id}`, method: 'PUT', body: data }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Role', id }, 'Role'],
    }),
    deleteRole: builder.mutation({
      query: (id) => ({ url: `roles/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Role'],
    }),
  }),
});

export const {
  useGetModulesQuery,
  useGetModuleByIdQuery,
  useCreateModuleMutation,
  useUpdateModuleMutation,
  useDeleteModuleMutation,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useGetRolePermissionsQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = moduleRoleApi;
